import { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import FooterNav from '../../components/dashboard/FooterNav';
import Navbar from '../../components/dashboard/Navbar';
import Slider from '../../components/Slider';
import Main from '../../components/dashboard/Main';
import PoInvoiceComponent from '../../components/dashboard/PoInvoice';

import axios from  'axios';
import jwtDecode from 'jwt-decode';
import { Link, useNavigate, useParams } from "react-router-dom";

const verifyToken = (serviceToken) => {
    if (!serviceToken) {
        return false;
    }
    const decoded = jwtDecode(serviceToken);
    /**
     * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
     */
    return decoded.exp > Date.now() / 1000;
};

const PoInvoice = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [token, setToken] = useState(
        JSON.parse(localStorage.getItem('token')) !== null ? 
            JSON.parse(localStorage.getItem('token')).token :
            null
    );
    const [data, setData] = useState([]);
    const [dataProgress, setDataProgress] = useState([]);
    const [poData, setPoData] = useState([])
    const [poForm, setPoForm] = useState([]);
    const [stokInfo, setStokInfo] = useState([]);
    const [withStok, setWithStok] = useState(false);
    const [dataHeader, setDataHeader] = useState(null);
    const [rekeningku, setRekeningku] = useState([]);
    const [authData, setAuthData] = useState({});
    const [loading, setLoading] = useState(true);
    const [dataCustom, setDataCustom] = useState([]);

    const [cartState, setCartState] = useState([]);

    useEffect(() => {
        const auth = async () => {
            try {
                let idMitra = null;
                const me = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/me`,
                  {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                  }
                );
                setAuthData(me.data.result);
            } catch (err) {
              console.log(err);
            }
        };

        const getInvoice = async () => {
            try {
                setLoading(true);
                const po = await axios.get(
                  `${process.env.REACT_APP_API_URL}/api/dashboard/preorder/invoice/${params.invoice}`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                  }).then((po) => {
                    let number = 0;
                    const dataLoopCustom = [];
                    const dataLoop = [];
                    po.data.result.forEach((value) => {
                        // if (value.custom !== null) {
                        //     dataLoopCustom.push(value);
                        // } else {
                        //     dataLoop.push(value);
                        // }
                        dataLoop.push(value);
                    })

                    // setDataCustom(dataLoopCustom.map(valueCustom => {
                    //     number+=1;
                    //     return { ...valueCustom, no: number };
                    // }));

                    setData(dataLoop.map((v) => {
                        number+=1;
                        return { ...v, no: number };
                    }));
                    setLoading(false);
                  });

            } catch (err) {
                console.log(err);
            }
        };

        const getInvoiceHeader = async () => {
            try {
                const po = await axios.get(
                  `${process.env.REACT_APP_API_URL}/api/dashboard/preorder/invoice/header/${params.invoice}`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                });

                setDataHeader(po.data.result);

            } catch (err) {
                console.log(err);
            }
        };

        const getPoDetail = async () => {
            try {
                const po = await axios.get(
                  `${process.env.REACT_APP_API_URL}/api/dashboard/preorder/detail/${params.idpoproduk}`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    }
                  });
                setPoData(po.data.result);

            } catch (err) {
                console.log(err);
            }
        };

        const getFormPo = async () => {
            try {
                const poform = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/form/update/${params.idpoproduk}`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    },
                    params: {
                        idpoproduk: params.idpoproduk,
                        invoice: params.invoice
                    }
                });

                let number = 0;
                let arrStok = [];
                let mappedPoForm = {};

                const form = poform.data.result.form.map((v) => {
                    number+=1;
                    const val = {};
                    val.prevValue = v.pomitra !== null ? v.pomitra.jumlah : 0;
                    val.prevStok = v.stok;
                    val.value = v.pomitra !== null ? v.pomitra.jumlah : 0;
                    val.stokUpdate = 0;
                    val.total = v.pomitra !== null ? v.pomitra.total : 0; // jumlah baru dikali harga satuan
                    val.idpo = v.idpo;
                    val.idpoproduk = v.idpoproduk;
                    val.idpodetail = v.idpodetail;
                    return {...v, no: number, [`po_${v.idpodetail}`]: val}
                });

                if (poform.data.result.jenis_po === "PO dengan Stok") {
                    setWithStok(true);
                    const mappedStok = poform.data.result.form.map((e) => {
                        return { idpo: e.idpo, namakategori: e.namakategori, stok: e.stok }
                    })
                    arrStok = mappedStok.filter((value, index, self) =>
                        index === self.findIndex((t) => (
                            t.idpo === value.idpo
                        ))
                    );
                }

                mappedPoForm.jenis_po = poform.data.result.jenis_po;
                mappedPoForm.form = form

                await setPoForm(mappedPoForm);
                await localStorage.setItem('originalPoForm', JSON.stringify(mappedPoForm));
                await setStokInfo(arrStok);
                await localStorage.setItem('originalStock', JSON.stringify(arrStok));
  
            } catch (err) {
                console.log(err);
            }
        };

        const getRekeningku = async () => {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/rekeningku`, {
                headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                }
            });
            let number = 0;
            setRekeningku(res.data.result.map((v) => {
                number+=1;
                return { ...v, no: number };
            }));
        };

        const getPoProgress = async () => {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/preorder/progress/${params.invoice}`, {
                headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                }
            });

            let number = 0;
            setDataProgress(res.data.result.map((v) => {
                number+=1;
                return { ...v, no: number };
            }));
        };

        const getCart = async () => {
            try {
              const cartData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/list`, {
                headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                }
              });
              setCartState(cartData.data.result);
            } catch (err) {
              console.log(err);
            }
        };

        if(!verifyToken(token)){
            localStorage.removeItem('token');
            navigate('/');
        }

        getInvoice();
        getInvoiceHeader();
        getPoDetail();
        getFormPo();
        getRekeningku();
        getCart();
        getPoProgress();
        auth();

    }, []);

    return (
        <div>
            <Navbar cartState={cartState} UpdatedCartState={setCartState} />
            <PoInvoiceComponent
                invoiceData={data}
                invoiceDataCustom={dataCustom}
                header={dataHeader}
                poForm={poForm}
                poData={poData}
                poProgress={dataProgress}
                withStok={withStok}
                updatedWithStok={setWithStok}
                updatedStokInfo={setStokInfo}
                updatedPoForm={setPoForm}
                updatedInvoice={setData}
                updatedPoData={setPoData}
                stokInfo={stokInfo}
                rekeningku={rekeningku}
                updatedRekeningku={setRekeningku}
                authData={authData}
                loading={loading}
                updatedLoading={setLoading}
            />
            <FooterNav />
        </div>
    )
}

export default PoInvoice
